/* ============================================================
   pf-bg-particles.js — Fondo de partículas de las fichas.
   Vanilla, sin librerías. Dos colores (variables --pf-bg-dot-a / --pf-bg-dot-b / --pf-bg-line).
   Puntos que derivan + líneas de conexión (constelación).
   - El dibujo va en un hilo aparte (Web Worker + OffscreenCanvas) para no ocupar el hilo principal
     de la página; si el navegador no lo admite, se dibuja aquí mismo como antes.
   - Las líneas se agrupan por opacidad: mismo dibujo, muchas menos órdenes de pintado.
   - DPR-aware, se redimensiona con la ventana; se pausa con la pestaña oculta.
   - Si el sistema pide "reducir movimiento": un fotograma estático.
   - Arranca cuando la página ya ha cargado, para no competir con la foto y los textos.
   ============================================================ */
(function () {
  if (window.__pfBgParticles) return;
  window.__pfBgParticles = true;

  function readRGB(name, fallback) {
    try {
      var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
      var m = v.match(/(\d+(?:\.\d+)?)[\s,]+(\d+(?:\.\d+)?)[\s,]+(\d+(?:\.\d+)?)/);
      if (m) return [Math.round(+m[1]), Math.round(+m[2]), Math.round(+m[3])];
    } catch (e) {}
    return fallback;
  }

  /* Motor de dibujo: el mismo código corre en el worker o, de respaldo, en la página. */
  function motor(scope) {
    var canvas, ctx, RASP, SKY, LINE, reduce;
    var dpr = 1, w = 0, h = 0, link = 132;
    var dots = [], running = false, hidden = false, last = 0;
    var BUCKETS = 24, MAXA = 0.16, lineStyles = [], paths = [];
    var raf = scope.requestAnimationFrame ? scope.requestAnimationFrame.bind(scope) : function (cb) { return scope.setTimeout(function () { cb(Date.now()); }, 16); };

    function build() {
      var n = Math.round((w * h) / 13000);
      n = Math.max(28, Math.min(n, w < 760 ? 60 : 150));
      link = w < 760 ? 108 : 132;
      dots = [];
      for (var i = 0; i < n; i++) {
        var isRasp = Math.random() < 0.62;
        var c = isRasp ? RASP : SKY, a = 0.35 + Math.random() * 0.45;
        dots.push({
          x: Math.random() * w,
          y: Math.random() * h,
          vx: (Math.random() - 0.5) * 0.28,
          vy: (Math.random() - 0.5) * 0.28,
          r: (isRasp ? 1.1 : 1.5) + Math.random() * 1.6,
          f: 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')'
        });
      }
    }

    function size(cw, ch, cdpr) {
      w = cw; h = ch; dpr = cdpr;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      build();
      if (reduce) draw(false);
    }

    function draw(move) {
      ctx.clearRect(0, 0, w, h);
      var i, p, q, n = dots.length;
      if (move) {
        for (i = 0; i < n; i++) {
          p = dots[i];
          p.x += p.vx;
          p.y += p.vy;
          if (p.x < -20) p.x = w + 20; else if (p.x > w + 20) p.x = -20;
          if (p.y < -20) p.y = h + 20; else if (p.y > h + 20) p.y = -20;
        }
      }
      var linkSq = link * link;
      for (q = 0; q < BUCKETS; q++) paths[q].length = 0;
      for (var a = 0; a < n; a++) {
        var pa = dots[a];
        for (var b = a + 1; b < n; b++) {
          var pb = dots[b];
          var dx = pa.x - pb.x, dy = pa.y - pb.y;
          var d2 = dx * dx + dy * dy;
          if (d2 < linkSq) {
            q = ((1 - Math.sqrt(d2) / link) * BUCKETS) | 0;
            if (q >= BUCKETS) q = BUCKETS - 1;
            paths[q].push(pa.x, pa.y, pb.x, pb.y);
          }
        }
      }
      ctx.lineWidth = 1;
      for (q = 0; q < BUCKETS; q++) {
        var seg = paths[q];
        if (!seg.length) continue;
        ctx.strokeStyle = lineStyles[q];
        ctx.beginPath();
        for (i = 0; i < seg.length; i += 4) { ctx.moveTo(seg[i], seg[i + 1]); ctx.lineTo(seg[i + 2], seg[i + 3]); }
        ctx.stroke();
      }
      for (i = 0; i < n; i++) {
        p = dots[i];
        ctx.beginPath();
        ctx.fillStyle = p.f;
        ctx.arc(p.x, p.y, p.r, 0, 6.2832);
        ctx.fill();
      }
    }

    function loop(ts) {
      if (!running) return;
      raf(loop);
      if (hidden) return;
      if (ts - last < 26) return;      /* ~38 fps máx. */
      last = ts;
      draw(true);
    }

    return function (msg) {
      if (msg.type === 'init') {
        canvas = msg.canvas; ctx = canvas.getContext('2d');
        RASP = msg.rasp; SKY = msg.sky; LINE = msg.line; reduce = msg.reduce;
        for (var q = 0; q < BUCKETS; q++) {
          lineStyles.push('rgba(' + LINE[0] + ',' + LINE[1] + ',' + LINE[2] + ',' + (((q + 0.5) / BUCKETS) * MAXA).toFixed(4) + ')');
          paths.push([]);
        }
        size(msg.w, msg.h, msg.dpr);
        if (!reduce) { running = true; raf(loop); }
      } else if (msg.type === 'size') {
        size(msg.w, msg.h, msg.dpr);
      } else if (msg.type === 'hidden') {
        hidden = msg.hidden;
      }
    };
  }

  function init() {
    var canvas = document.querySelector('.pf-bg-canvas');
    if (!canvas) return;

    var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    function medidas() {
      return {
        w: canvas.clientWidth || window.innerWidth,
        h: canvas.clientHeight || window.innerHeight,
        dpr: Math.min(window.devicePixelRatio || 1, 2)
      };
    }
    var m = medidas();
    var datos = {
      type: 'init', reduce: reduce, w: m.w, h: m.h, dpr: m.dpr,
      rasp: readRGB('--pf-bg-dot-a', [194, 24, 91]),
      sky: readRGB('--pf-bg-dot-b', [224, 242, 254]),
      line: readRGB('--pf-bg-line', [194, 24, 91])
    };

    var enviar = null;
    if (canvas.transferControlToOffscreen && window.Worker && window.Blob && window.URL) {
      try {
        var codigo = 'var recibir=(' + motor.toString() + ')(self);self.onmessage=function(e){recibir(e.data);};';
        var url = URL.createObjectURL(new Blob([codigo], { type: 'text/javascript' }));
        var worker = new Worker(url);
        var off = canvas.transferControlToOffscreen();
        datos.canvas = off;
        worker.postMessage(datos, [off]);
        enviar = function (msg) { worker.postMessage(msg); };
      } catch (e) { enviar = null; }
    }
    if (!enviar) {
      if (!canvas.getContext || !canvas.getContext('2d')) return;
      var recibir = motor(window);
      datos.canvas = canvas;
      recibir(datos);
      enviar = recibir;
    }

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var n = medidas();
        enviar({ type: 'size', w: n.w, h: n.h, dpr: n.dpr });
      }, 180);
    });
    document.addEventListener('visibilitychange', function () {
      enviar({ type: 'hidden', hidden: document.hidden });
    });
    if (document.hidden) enviar({ type: 'hidden', hidden: true });
  }

  function start() {
    if (window.requestIdleCallback) requestIdleCallback(init, { timeout: 1500 }); else setTimeout(init, 200);
  }
  if (document.readyState === 'complete') start();
  else window.addEventListener('load', start, { once: true });
})();
